'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  field: null,
  operator: null,
  value: {
    name: '',
    code: ''
  },
  valueType: 'value'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/arcgis-filter/dist/defaults/expression.js
// module id = 1638
// module chunks = 0